// extracted by mini-css-extract-plugin
export var checkboxInputRow = "z_tC";
export var checkboxInputColumn = "z_tD";
export var inputOptionRow = "z_qC";
export var inputOptionColumn = "z_qD";